import React from "react";
import "./App.css";
import Header from "./components/layout/Header";
import Menu from "./components/layout/Menu";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashborad from "./components/pages/dashboard/Dashboard";

import { SnackbarProvider } from "./contexts/SnackbarContext";
import SnackbarComponent from "./components/common/snakebar/SnakebarComponnet";
import DynamicTitleAndIcon from "./components/common/dynamicTitleAndIcon/DynamicTitleAndIcon ";
import useAuth from "./constant/auth/useAuth";
import NetworkStatusMonitor from "./components/common/networkStatus/NetworkStatusMonitor";
import FullPageLoader from "./constant/loading/FullPageLoading";
import UnauthorizedPage from "./components/pages/unAuthorizedPage/UnAuthorized";
import Login from "./components/pages/authentication/Login";
import ForgotPassword from "./components/pages/authentication/ForgotPassword";
import ResetPassword from "./components/pages/authentication/ResetPassword";
import VerifyOTP from "./components/pages/authentication/VerifyOTP";
import AllStore from "./components/pages/stores/AllStores";
import StoreSetting from "./components/pages/stores/StoreSetting";

function App() {
  return (
    <SnackbarProvider>
      <SnackbarComponent />
      <NetworkStatusMonitor />
      <DynamicTitleAndIcon />
      <MainAppContent />
    </SnackbarProvider>
  );
}

function MainAppContent() {
  const { drawerOpen, setDrawerOpen, loggedIn, setLoggedIn, loading } =
    useAuth();

  if (loading) {
    return <FullPageLoader loading={true} />;
  }

  return (
    <div>
      {!loggedIn ? (
        <>
          <Routes>
            <Route
              path="/login"
              element={<Login setLoggedIn={setLoggedIn} to="/login" />}
            />
              <Route path="/reset-password" element={<ResetPassword setLoggedIn={setLoggedIn} />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<VerifyOTP />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
          </Routes>
        </>
      ) : (
        <div className="app">
          <Header
            setDrawerOpen={setDrawerOpen}
            drawerOpen={drawerOpen}
            setLoggedIn={setLoggedIn}
          />
          <div className="main">
            {drawerOpen && <Menu open={drawerOpen} setOpen={setDrawerOpen} />}
            <div
              className={`content ${
                drawerOpen ? "content-open" : "content-closed"
              }`}
            >
              <Routes>
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />

                <Route path="/dashboard" element={<Dashborad />} />
                <Route path="/all-stores" element={<AllStore />} />
                 <Route path="/all-stores" element={<StoreSetting />} />
              </Routes>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
